import React from "react";
import { IconButton } from "@mui/material";
import { TrashIcon } from "@/components/icons";
import { Badge, BadgeProps } from "@/components/Badge";
import { cn } from "@/helpers/utils";

interface DiscountBadgeProps extends Omit<BadgeProps, "children"> {
  discountName?: string;
  onChange?: () => void;
  disabled?: boolean;
}

const DiscountBadge = (props: DiscountBadgeProps) => {
  const { discountName, onChange, disabled, className, ...divProps } = props;

  return discountName ? (
    <Badge
      color="white"
      size="base"
      aria-disabled={disabled}
      {...divProps}
      className={cn(
        "justify-between space-x-8 pr-0",
        disabled && "cursor-not-allowed opacity-50",
        className
      )}
    >
      <span>{discountName.toLocaleUpperCase()}</span>
      {onChange && (
        <IconButton
          className="px-2 py-1 transition not-disabled:hover:opacity-50"
          onClick={onChange}
          disabled={disabled}
        >
          <TrashIcon
            htmlColor="hsl(var(--color-primary))"
            style={{ height: "16px", width: "16px" }}
          />
        </IconButton>
      )}
    </Badge>
  ) : (
    <span className={cn("inline-block text-sm", className)}>
      No discount applied.
    </span>
  );
};

export { DiscountBadge };
